import { Row } from "react-bootstrap";
import Inicio from "../componentes/Inicio";

const InicioPagina = () => (
  <Row as="main">
    <Inicio />
  </Row>
);

export default InicioPagina;
